// @flow

import * as React from 'react';
import { connect } from 'react-redux';
import type { Dispatch } from 'redux';

import { setPopUp } from 'client/actions/pop-up';

import InfoPopUp from './InfoPopUp';

const mapToDispatch = (dispatch: Dispatch<{ type: string }>) => ({
	closePopUp: () => dispatch(setPopUp(null)),
});

export default (connect(null, mapToDispatch)(InfoPopUp): React.AbstractComponent<{}>);
